import {
  ISideBySideQuestionModelState,
  ISideBySideResponseValidation,
  SideBySideQuestionModelTypes,
  SideBySideResponse
} from './types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import BaseQuestionModel from '../BaseQuestionModel'
import { makeResponse } from './functions'

const SideBySideQuestionModel: IQuestionModelConstructor<SideBySideQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<SideBySideQuestionModelTypes, ISideBySideQuestionModelState>({
    questionType: QuestionType.SIDE_BY_SIDE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response, questionSchema }: ISideBySideQuestionModelState) {
  return makeResponse(questionSchema, response)
}

function initState(state: ISideBySideQuestionModelState): ISideBySideQuestionModelState {
  state.response = [] as SideBySideResponse
  return state
}

function validateResponse({ questionSchema }: ISideBySideQuestionModelState): ISideBySideResponseValidation {
  // if (responseValidation) return responseValidation

  if (questionSchema.answers.filter(a => !a.hidden).length < 2) return { valid: true }

  return {
    valid: false
  }
}

export default SideBySideQuestionModel
